'use strict';

var $ = (typeof window !== "undefined" ? window.jQuery : typeof global !== "undefined" ? global.jQuery : null);

var notify = require('notify');
var triggerCustomEvent = require('trigger-custom-event');
var pbizServer = (typeof window !== "undefined" ? window.pbizServer : typeof global !== "undefined" ? global.pbizServer : null);

var appDom = require('../../app-dom');
var scrollToElement = require('scroll-to-element');

var dom;
var addToCartText;

var setupDom = function() {

	dom = {};
	dom.serviceDetail = $('.scheduler-detail');
	dom.serviceForm = dom.serviceDetail.find('.scheduler-detail__form');

};

var addEventHandlers = function() {

	dom.serviceDetail.off('.scheduler_detail');
	dom.serviceDetail.on('change.scheduler_detail', '.scheduler-detail__option', onServiceOptionChanged);
	// dom.serviceDetail.on('click.scheduler_detail', '.js-add-to-cart', onAddToCartBtnClicked);
	dom.serviceDetail.on('click.scheduler_detail', '.js-schedule-btn', onScheduleBtnClicked);
	appDom.document.off('.scheduler_detail');

};

var onScheduleBtnClicked = function() {

	triggerCustomEvent('schedule_button_clicked');

};

var grabFormData = function(formArray) {

	var returnArray = {};

	for (var i = 0; i < formArray.length; i++){
		returnArray[formArray[i]['name']] = formArray[i]['value'];
	}

	return returnArray;

};

var onAddToCartBtnClicked = function(e) {

	var $btn = $(this);

	dom.serviceForm = $btn.parents('.scheduler-detail__form');

	var data = grabFormData(dom.serviceForm.serializeArray());

	addToCartText = $btn.text();

	$btn.text(pbizServer.content['Generic.Loading']);

	// add some custom goodies
	data['sku'] = $btn.attr('data-sku') ? $btn.attr('data-sku') : '';
	data['sourceUrl'] = $btn.attr('data-item-url');

	e.preventDefault();

	$.ajax({
		url: '/index.cfm?action=cart.add',
		method: 'POST',
		dataType: 'JSON',
		data: data
	}).done(onAddToCartLinkClickedDone);

};


var onAddToCartLinkClickedDone = function(response) {

	if (response.status.code) {

		triggerCustomEvent('item_added_to_cart');

		onItemAddedToCart();

	} else {

		dom.serviceForm.find('.scheduler-detail__add-to-cart-btn').text(addToCartText);

		notify.show({
			target: $('[name="' + response.target + '"]'),
			msg: response.status.msg,
			closeOnClick: true
		});

	}

};


var onItemAddedToCart = function() {

	notify.hide();

	resetServiceForm();

};

var resetServiceForm = function() {

	var $selectBoxes = dom.serviceForm.find('select');
	var $textInputs = dom.serviceForm.find('input[type="text"]');
	var $textareas = dom.serviceForm.find('textarea');
	var $addToCartBtn = dom.serviceForm.find('.scheduler-detail__add-to-cart-btn');

	$selectBoxes.each(function(i, el) {

		$(el).find('option:eq(0)').attr('selected', 'selected');

	});

	$textInputs.each(function(i, el) {

		$(el).val('');

	});

	$textareas.each(function(i, el) {

		$(el).val('');

	});

	loadServiceForm();

};

var onServiceOptionChanged = function() {

	var $selectedOption = $(this).find('option:selected');

	dom.serviceForm = $(this).parents('.scheduler-detail__form');

	notify.hide();

	loadServiceForm();

};

var loadServiceForm = function(isInitialLoad) {

	isInitialLoad = typeof isInitialLoad !== 'undefined' ? isInitialLoad : false;

	dom.serviceForm.each(function(i, el, a) {

		console.log(el);

		$.ajax({
			url: '/index.cfm?action=scheduler.detailForm',
			method: 'POST',
			data: dom.serviceForm.eq(i).serialize() + '&isInitialLoad=' + isInitialLoad
		}).done(onLoadProductFormDone);

	});

};

var onLoadProductFormDone = function(response) {

	var $cachedForm = dom.serviceForm;

	if (response.status) {

		dom.serviceForm.filter('[data-item-id=' + response.itemId + ']').html(response.markup);

		setupDom();

		addEventHandlers();

	}

};

var init = function() {

	setupDom();

	addEventHandlers();

	loadServiceForm(true);

};

module.exports = {
	init: init
};
